import { createContext } from 'react';

import type { VenueDetail } from '../../../../api/venues';

export const MARKETING_ONLY_HINT = 'Marketing users can edit the Marketing tab only';
export const VIEW_ONLY_HINT = 'You can view this venue but not edit it';
export const NO_MARKETING_HINT = "You can't edit marketing for this venue";

/** Why a locked section cannot be edited. Null outside a tab panel. */
export const LockedHintContext = createContext<string | null>(null);

/** The reason shown to someone who cannot edit, from what the server says they may do. */
export function lockedHintFor(venue: Pick<VenueDetail, 'canEdit' | 'canWriteMarketing'>) {
  if (venue.canWriteMarketing && !venue.canEdit) return MARKETING_ONLY_HINT;
  if (venue.canEdit && !venue.canWriteMarketing) return NO_MARKETING_HINT;
  return VIEW_ONLY_HINT;
}
